import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { FcChoiceDialogService } from '@core/components/fc-choice-dialog/fc-choice-dialog.service';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { UploadCredentialEntityEnum } from '@core/interfaces';
import { UploadService } from '@core/services/upload.service';
import { getErrorCode } from '@core/utils/get-error-code';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { TranslateService } from '@ngx-translate/core';
import { RecurrenceService } from 'app/main/recurrences/services/recurrence.service';
import { ImportsService } from 'app/main/settings/imports/services/imports.service';
import { EquipmentsTypesApi } from 'app/main/settings/registers/equipments-types/services/api/equipments-types-api.service';
import { isValid } from 'date-fns';
import { sentry } from 'sentry';
import { FuseTranslationLoaderService } from '../../../../@fuse/services/translation-loader.service';
import { EquipmentsService } from '../services/equipments-resolver.service';
import { TabQrCodeComponent } from './tabs/qrcode/tab-qr-code.component';
import english from '../i18n/en.json';
import spanish from '../i18n/es.json';
import portuguese from '../i18n/pt.json';
import { DialogEquipmentTabsEnum } from './dialog-equipments.types';
var QR_CODE_TAB_INDEX = 5;
var DialogEquipmentComponent = /** @class */ (function () {
    function DialogEquipmentComponent(data, matDialogRef, customMessageService, authenticationService, equipmentsTypesApi, equipmentsService, recurrenceService, progressBar, importsService, uploadService, formBuilder, fuseTranslationLoaderService, changeDetectorRef, fcChoiceDialogService, translateService) {
        var _this = this;
        this.data = data;
        this.matDialogRef = matDialogRef;
        this.customMessageService = customMessageService;
        this.authenticationService = authenticationService;
        this.equipmentsTypesApi = equipmentsTypesApi;
        this.equipmentsService = equipmentsService;
        this.recurrenceService = recurrenceService;
        this.progressBar = progressBar;
        this.importsService = importsService;
        this.uploadService = uploadService;
        this.formBuilder = formBuilder;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.changeDetectorRef = changeDetectorRef;
        this.fcChoiceDialogService = fcChoiceDialogService;
        this.translateService = translateService;
        this.selectedTabIndex = 0;
        this.isUpdate = false;
        this.isSaving = false;
        this.isViewMode = !this.authenticationService.hasPermission('equipments-edit');
        this.hasFlagWarranties = this.authenticationService.hasFlags(['warranties']);
        this.hasCreateWarrantyPermission = this.authenticationService.hasPermission('warranties-create');
        this.hasEditWarrantyPermission = this.authenticationService.hasPermission('warranties-edit');
        this.reloadDataTable = false;
        this.equipmentWarrantiesUpdatedHandler = function () {
            _this.reloadDataTable = true;
        };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    DialogEquipmentComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.equipment = this.data.equipment;
                this.isUpdate = this.data.equipment && this.data.equipment.id;
                this.equipmentId = this.isUpdate ? this.data.equipment.id : null;
                this.equipmentForm = this.formBuilder.group({
                    name: new FormControl(this.equipment.name || null, [Validators.required]),
                    number: new FormControl(this.equipment.number || null, [Validators.required]),
                    qrCode: new FormControl(this.equipment.qrCode || null, [Validators.required]),
                    notes: new FormControl(this.equipment.notes || ''),
                    type: new FormControl(this.equipment.type || null, [Validators.required]),
                    customFields: new FormArray([]),
                });
                this.equipmentForm.addControl('location', new FormControl({
                    value: this.equipment.location || null,
                    disabled: this.data.disableEditLocation
                }, [Validators.required]));
                this.equipmentForm.addControl('sector', new FormControl({
                    value: this.equipment.locationSector || null,
                    disabled: !this.equipment.location
                }));
                this.equipmentForm.addControl('environment', new FormControl({
                    value: this.equipment.locationEnvironment || null,
                    disabled: !this.equipment.locationSector
                }));
                this.equipmentForm.addControl('imageUrl', new FormControl(this.equipment.imageUrl ? { thumb: this.equipment.imageUrl } : null));
                this.equipmentForm.addControl('installedAt', new FormControl(this.equipment.installedAt || null));
                this.equipmentForm.addControl('purchasedAt', new FormControl(this.equipment.purchasedAt || null));
                if (this.isViewMode) {
                    this.equipmentForm.disable();
                }
                this.equipmentForm.get('type').valueChanges.subscribe(function (equipmentType) {
                    _this.changeEquipmentType(equipmentType);
                });
                this.changeEquipmentType(this.equipmentForm.get('type').value);
                this.equipmentForm
                    .get('location')
                    .valueChanges
                    .subscribe(function (value) {
                    _this.equipmentForm.get('environment').setValue(null);
                    _this.equipmentForm.get('sector').setValue(null);
                    _this.equipmentForm.get('environment').disable();
                    _this.equipmentForm.get('sector')[value ? 'enable' : 'disable']();
                });
                this.equipmentForm.get('sector').valueChanges.subscribe(function (value) {
                    _this.equipmentForm.get('environment').setValue(null);
                    _this.equipmentForm.get('environment')[value ? 'enable' : 'disable']();
                });
                this.matDialogRef.beforeClosed()
                    .subscribe(function () {
                    if (_this.reloadDataTable) {
                        window.emitEvent('equipment-closed');
                    }
                    window.removeEventListener('equipment-warranties-updated', _this.equipmentWarrantiesUpdatedHandler);
                });
                window.addEventListener('equipment-warranties-updated', this.equipmentWarrantiesUpdatedHandler);
                return [2 /*return*/];
            });
        });
    };
    DialogEquipmentComponent.prototype.ngAfterViewInit = function () {
        if (this.data.selectedTab) {
            this.selectedTabIndex = Number(DialogEquipmentTabsEnum[this.data.selectedTab]) || 0;
            this.changeDetectorRef.detectChanges();
        }
    };
    DialogEquipmentComponent.prototype.changeEquipmentType = function (equipmentType) {
        var _this = this;
        if (equipmentType && equipmentType.id) {
            this.equipmentsTypesApi
                .getEquipmentTypeById(equipmentType.id)
                .subscribe(function (response) {
                _this.setCustomFields(response.customFields);
            });
        }
    };
    DialogEquipmentComponent.prototype.setCustomFields = function (customFields) {
        var _this = this;
        var customFieldsArray = this.formBuilder.array(customFields.map(function (customField) {
            var customFieldFormGroup = _this.formBuilder.group({
                name: _this.formBuilder.control(customField.name),
                value: _this.formBuilder.control(null),
                required: _this.formBuilder.control(customField.required || false),
                type: _this.formBuilder.control(customField.type),
                options: _this.formBuilder.array(customField.options.map(function (option) {
                    return _this.formBuilder.group({
                        value: _this.formBuilder.control(option.value),
                    });
                }))
            });
            if (customField.required) {
                customFieldFormGroup.get('value').setValidators(Validators.required);
            }
            if (_this.isViewMode) {
                customFieldFormGroup.disable();
            }
            return customFieldFormGroup;
        }));
        customFieldsArray.controls.forEach(function (customFieldFormGroup) {
            var customFieldWithSameName = _this.equipment.customFields.find(function (customFieldFromEquipment) { return customFieldFromEquipment.name === customFieldFormGroup.value.name; });
            if (customFieldWithSameName) {
                customFieldFormGroup.get('value').setValue(customFieldWithSameName.value);
            }
        });
        this.equipmentForm.setControl('customFields', customFieldsArray);
        this.changeDetectorRef.detectChanges();
    };
    DialogEquipmentComponent.prototype.archiveOrUnarchiveEquipment = function (archived) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.equipment.archived = archived;
                return [2 /*return*/, this.generateInputToSave()];
            });
        });
    };
    DialogEquipmentComponent.prototype.generateInputToSave = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var formValue, equipmentInput, recurrences, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formValue = this.equipmentForm.getRawValue();
                        equipmentInput = {
                            archived: this.equipment.archived,
                            name: formValue.name,
                            notes: formValue.notes,
                            number: formValue.number,
                            qrCode: formValue.qrCode,
                            equipmentTypeId: formValue.type.id,
                            locationId: formValue.locationId,
                            customFields: formValue.customFields.map(function (customField) { return ({
                                name: customField.name,
                                value: String(customField.value),
                                type: customField.type
                            }); })
                        };
                        equipmentInput.locationId = formValue.location.id;
                        equipmentInput.purchasedAt = formValue.purchasedAt;
                        equipmentInput.installedAt = formValue.installedAt;
                        equipmentInput.locationSectorId = formValue.sector ? formValue.sector.id : null;
                        equipmentInput.locationEnvironmentId = formValue.environment ? formValue.environment.id : null;
                        equipmentInput.imageUrl = formValue.imageUrl && formValue.imageUrl.thumb === this.equipment.imageUrl ? this.equipment.imageUrl : formValue.imageUrl;
                        if (!(this.equipment &&
                            this.equipment.id &&
                            (equipmentInput.locationSectorId !== (this.equipment.locationSector && this.equipment.locationSector.id) ||
                                equipmentInput.locationEnvironmentId !== (this.equipment.locationEnvironment && this.equipment.locationEnvironment.id)))) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.recurrenceService.listRecurrences({
                                where: {
                                    equipmentId_in: this.equipment.id
                                },
                                options: {
                                    limit: 10000,
                                    offset: 0
                                }
                            })];
                    case 1:
                        recurrences = _a.sent();
                        if (!(recurrences.items && recurrences.items.length)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.openEquipmentRecurrencesOptions({ recurrences: recurrences, equipmentInput: equipmentInput })];
                    case 2:
                        result = _a.sent();
                        if (result !== 'confirm') {
                            return [2 /*return*/];
                        }
                        _a.label = 3;
                    case 3:
                        equipmentInput.customFields.forEach(function (customField, index) {
                            if (!customField.value) {
                                equipmentInput.customFields.splice(index, 1);
                            }
                            if (customField.type === 'date' && customField.value) {
                                var date = new Date(customField.value);
                                equipmentInput.customFields[index].value = isValid(date) ? date.toISOString() : null;
                            }
                        });
                        return [2 /*return*/, this.saveEquipment(equipmentInput)];
                }
            });
        });
    };
    DialogEquipmentComponent.prototype.openEquipmentRecurrencesOptions = function (_a) {
        var recurrences = _a.recurrences, equipmentInput = _a.equipmentInput;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                return [2 /*return*/, this.fcChoiceDialogService.open({
                        title: this.translateService.instant('EQUIPMENTS.DIALOG.LINKED_AT_RECURRENCES_DIALOG.TITLE'),
                        description: this.translateService.instant('EQUIPMENTS.DIALOG.LINKED_AT_RECURRENCES_DIALOG.DESCRIPTION'),
                        options: [
                            {
                                text: this.translateService.instant('EQUIPMENTS.DIALOG.LINKED_AT_RECURRENCES_DIALOG.OPTIONS.KEEP_LINK'),
                                action: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                    return tslib_1.__generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, this.keepsEquipmentLinkedToRecurrences(recurrences, equipmentInput)];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); }
                            },
                            {
                                text: this.translateService.instant('EQUIPMENTS.DIALOG.LINKED_AT_RECURRENCES_DIALOG.OPTIONS.UNLINK'),
                                action: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                    return tslib_1.__generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, this.removeEquipmentLinkedToRecurrences(recurrences)];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); }
                            },
                        ]
                    })];
            });
        });
    };
    DialogEquipmentComponent.prototype.saveEquipment = function (equipmentInput) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var credential, savedEquipment, err_1, code;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isSaving = true;
                        this.progressBar.show();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        if (!(equipmentInput.imageUrl && equipmentInput.imageUrl.thumb && equipmentInput.imageUrl.thumb !== this.equipment.imageUrl)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.importsService.createUploadCredential({
                                size: equipmentInput.imageUrl.size,
                                extension: equipmentInput.imageUrl.filename.split('.').pop(),
                                entity: UploadCredentialEntityEnum.equipments
                            })];
                    case 2:
                        credential = _a.sent();
                        return [4 /*yield*/, this.uploadService.uploadWithCredentials({
                                fields: credential.fields,
                                baseUrl: credential.baseUrl,
                                file: equipmentInput.imageUrl.file
                            })];
                    case 3:
                        _a.sent();
                        equipmentInput.imageUrl = credential.link;
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this.equipmentsService.saveEquipment(this.equipment.id, equipmentInput)];
                    case 5:
                        savedEquipment = _a.sent();
                        this.customMessageService.success('EQUIPMENTS.SUCCESS_MESSAGE');
                        this.matDialogRef.close({
                            reload: true,
                            equipment: savedEquipment
                        });
                        this.reloadDataTable = true;
                        return [3 /*break*/, 8];
                    case 6:
                        err_1 = _a.sent();
                        code = getErrorCode(err_1);
                        if (code === 'equipment_qr_code_duplicated') {
                            this.selectedTabIndex = 0;
                            this.equipmentForm.get('qrCode').setErrors({
                                'equipment_qr_code_duplicated': true
                            });
                            return [2 /*return*/];
                        }
                        if (code === 'equipment_number_duplicated') {
                            this.selectedTabIndex = 0;
                            this.equipmentForm.get('number').setErrors({
                                'equipment_number_duplicated': true
                            });
                            return [2 /*return*/];
                        }
                        this.customMessageService.error('EQUIPMENTS.ERROR_MESSAGE');
                        sentry.captureException(err_1);
                        return [3 /*break*/, 8];
                    case 7:
                        this.progressBar.hide();
                        this.isSaving = false;
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    DialogEquipmentComponent.prototype.gotoQrCodeTab = function () {
        this.selectedTabIndex = QR_CODE_TAB_INDEX;
    };
    DialogEquipmentComponent.prototype.keepsEquipmentLinkedToRecurrences = function (recurrences, equipmentInput) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, recurrence, newRecurrenceSectors, newRecurrenceEnvironments, e_1_1;
            var e_1, _c;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 5, 6, 7]);
                        _a = tslib_1.__values(recurrences.items), _b = _a.next();
                        _d.label = 1;
                    case 1:
                        if (!!_b.done) return [3 /*break*/, 4];
                        recurrence = _b.value;
                        newRecurrenceSectors = recurrence.locationSectors.map(function (sector) { return sector.id; });
                        newRecurrenceEnvironments = recurrence.locationEnvironments.map(function (environment) { return environment.id; });
                        if (equipmentInput.locationSectorId) {
                            newRecurrenceSectors = tslib_1.__spread(newRecurrenceSectors, [equipmentInput.locationSectorId]);
                        }
                        if (equipmentInput.locationEnvironmentId) {
                            newRecurrenceEnvironments = tslib_1.__spread(newRecurrenceEnvironments, [equipmentInput.locationEnvironmentId]);
                        }
                        return [4 /*yield*/, this.recurrenceService.update(recurrence.id, {
                                locationSectorIds: newRecurrenceSectors || undefined,
                                locationEnvironmentIds: newRecurrenceEnvironments || undefined
                            })];
                    case 2:
                        _d.sent();
                        _d.label = 3;
                    case 3:
                        _b = _a.next();
                        return [3 /*break*/, 1];
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        e_1_1 = _d.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 7];
                    case 6:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    DialogEquipmentComponent.prototype.removeEquipmentLinkedToRecurrences = function (recurrences) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, recurrence, newRecurrenceEquipments, e_2_1;
            var e_2, _c;
            var _this = this;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 5, 6, 7]);
                        _a = tslib_1.__values(recurrences.items), _b = _a.next();
                        _d.label = 1;
                    case 1:
                        if (!!_b.done) return [3 /*break*/, 4];
                        recurrence = _b.value;
                        newRecurrenceEquipments = recurrence.equipments.map(function (equipment) { return equipment.id; }).filter(function (id) { return id !== _this.equipment.id; });
                        return [4 /*yield*/, this.recurrenceService.update(recurrence.id, {
                                equipmentIds: newRecurrenceEquipments || undefined
                            })];
                    case 2:
                        _d.sent();
                        _d.label = 3;
                    case 3:
                        _b = _a.next();
                        return [3 /*break*/, 1];
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        e_2_1 = _d.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 7];
                    case 6:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    DialogEquipmentComponent.prototype.onTabChange = function (event) {
        var _this = this;
        if (event.index === 1) {
            var container_1 = document.getElementById('equipment-container');
            if (container_1) {
                container_1.innerHTML = '';
                setTimeout(function () {
                    var element = document.createElement('equipment-with-warranties');
                    element.equipmentId = _this.equipmentId;
                    element.hasCreateWarrantyPermission = _this.hasCreateWarrantyPermission;
                    element.hasEditWarrantyPermission = _this.hasEditWarrantyPermission;
                    container_1.appendChild(element);
                }, 0);
            }
        }
    };
    return DialogEquipmentComponent;
}());
export { DialogEquipmentComponent };
